import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const PeakHoursConfig = ({ peakHours, onSave }) => {
  const [morningStart, setMorningStart] = useState(peakHours?.morning?.start || '07:30');
  const [morningEnd, setMorningEnd] = useState(peakHours?.morning?.end || '09:30');
  const [eveningStart, setEveningStart] = useState(peakHours?.evening?.start || '17:00');
  const [eveningEnd, setEveningEnd] = useState(peakHours?.evening?.end || '19:00');
  const [trafficMultiplier, setTrafficMultiplier] = useState(peakHours?.multiplier || '1.2');

  const handleSave = () => {
    onSave({
      morning: { start: morningStart, end: morningEnd },
      evening: { start: eveningStart, end: eveningEnd },
      multiplier: parseFloat(trafficMultiplier)
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 space-y-6">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center w-10 h-10 bg-warning/10 rounded-lg">
          <Icon name="TrendingUp" size={20} color="var(--color-warning)" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-foreground font-heading">
            Yoğun Saat Ayarları
          </h3>
          <p className="text-sm text-muted-foreground">
            Trafik yoğunluğu çarpanını yapılandırın
          </p>
        </div>
      </div>
      <div className="space-y-6">
        <div className="space-y-4 p-4 bg-muted/50 rounded-lg">
          <h4 className="text-sm font-semibold text-foreground">Sabah Yoğunluğu</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Başlangıç Saati"
              type="time"
              value={morningStart}
              onChange={(e) => setMorningStart(e?.target?.value)}
            />
            <Input
              label="Bitiş Saati"
              type="time"
              value={morningEnd}
              onChange={(e) => setMorningEnd(e?.target?.value)}
            />
          </div>
        </div>

        <div className="space-y-4 p-4 bg-muted/50 rounded-lg">
          <h4 className="text-sm font-semibold text-foreground">Akşam Yoğunluğu</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Başlangıç Saati"
              type="time"
              value={eveningStart}
              onChange={(e) => setEveningStart(e?.target?.value)}
            />
            <Input
              label="Bitiş Saati"
              type="time"
              value={eveningEnd}
              onChange={(e) => setEveningEnd(e?.target?.value)}
            />
          </div>
        </div>

        <div className="space-y-4 p-4 bg-muted/50 rounded-lg">
          <h4 className="text-sm font-semibold text-foreground">Trafik Çarpanı</h4>
          <Input
            label="Çarpan Değeri"
            type="number"
            step="0.1"
            min="1.0"
            max="2.0"
            value={trafficMultiplier}
            onChange={(e) => setTrafficMultiplier(e?.target?.value)}
            description="Yoğun saatlerde süre tahminine uygulanacak çarpan (örn: 1.2 = %20 artış)"
          />
        </div>

        <Button
          variant="default"
          fullWidth
          onClick={handleSave}
          iconName="Save"
          iconPosition="left"
        >
          Ayarları Kaydet
        </Button>
      </div>
      <div className="p-4 bg-primary/10 border border-primary rounded-lg">
        <div className="flex items-start gap-3">
          <div className="flex items-center justify-center w-6 h-6 bg-primary/20 rounded-full flex-shrink-0 mt-0.5">
            <Icon name="Info" size={14} color="var(--color-primary)" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs text-foreground mb-2 font-medium">
              Yoğun Saat Etkisi
            </p>
            <p className="text-xs text-muted-foreground">
              Bu ayarlar, tahmin algoritmasının yoğun saatlerde süre hesaplamalarını etkiler. Örneğin 1.2 çarpanı ile 30 dakikalık bir süre, yoğun saatlerde 36 dakika olarak hesaplanır.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeakHoursConfig;